<template>
  <div>
    <h3>Теги та категорії</h3>
    <b-card>
      <b-tabs content-class="mt-3">
        <b-tab active>
          <template #title>
            <b-icon-tag />
            &nbsp;
            <strong>Теги</strong>
          </template>
          <tags />
        </b-tab>
        <b-tab>
          <template #title>
            <b-icon-folder />
            &nbsp;
            <strong>Категорії</strong>
          </template>
          <categories />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import tags from "./tags.vue";
import categories from "./categories.vue";
export default {
  components: {
    tags,
    categories,
  },
};
</script>

<style lang="scss" scoped></style>
